export function tabs(isLabelsEnabled = false) {
  return [
    {
    id: 1,
    label: 'Office details',
    intlKey: 'tabs.office_details',
    path: '/detail',
    type: 'tab'
  },
  {
    id: 2,
    label: 'Related contacts',
    intlKey: 'tabs.related_contacts',
    path: '/related-contacts',
    type: 'tab'
  },
  {
    id: 3,
    label: 'Labels',
    intlKey: 'tabs.labels',
    path: '/labels',
    type: 'tab',
    visibility: !isLabelsEnabled ? 'hidden' : 'visible'
  },
    {
      id: 4,
      label: 'Customizations',
      intlKey: 'tabs.customizations',
      path: '/customizations',
      type: 'tab'
    }
  ]
}
